<template>
  <div :class="{'stringBox':true, 'stringBox--lines':answer.display_options.textInputFormat===3,
       'textLimitError': error, 'stringBox--oneLine': answer.display_options.textInputFormat!==3&&!isVertical,
       'stringBox--mathFieldWidth': isKeyboard && answer.label.length > 0, 'disabled-input': workStore.isWronglyAnswered && prevIsCorrectAnswer}">
    <div class="stringBox__string" v-if="isVertical">{{answer.body.prefix}}</div>
    <div class="stringBox__string" v-else-if="isKeyboard && answer.body.prefix.length > 0" v-html="prefixText"></div>
    <div class="stringBox__string" v-else-if="answer.body.prefix.length > 0">{{answer.body.prefix}}</div>
    <answer-text :answer="answer" :is-pre-suffix="true" :is-vertical="isVertical"
                 :is-keyboard="isKeyboard" :is-science="isScience" :is-souruby="isSouruby"
                 :tab-index="tabIndex"
                 :prev-answer-text="prevAnswerText"
                 :prev-is-correct-answer="prevIsCorrectAnswer"
                 @press-enter="emit('press-enter')"
                 @is-error="isError"
                 @set-is-focus="emit('set-is-focus', $event)"
                 @input-pre-suffix-text="emit('input-text', $event)"></answer-text>
    <div class="stringBox__string" v-if="isVertical">{{answer.body.suffix}}</div>
    <div class="stringBox__string" v-else-if="!isKeyboard && answer.body.suffix.length > 0">{{answer.body.suffix}}</div>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue"
  import {IQuiz} from "@/consts/interfaces";
  import { markdown as md } from "@/util/markdown";
  import { useWorkStore } from '@/store/student/work_store';

  const error = ref(false)
  const workStore = useWorkStore()

  const props = withDefaults(
    defineProps<{
      answer?: IQuiz;
      isVertical?: boolean;
      isKeyboard?: boolean;
      isScience?: boolean;
      tabIndex?: number;
      prevAnswerText?: string;
      prevIsCorrectAnswer?: boolean;
      isSouruby?: boolean;
    }>(),
    {
      answer: null,
      isVertical: false,
      isKeyboard: false,
      isScience: false,
      tabIndex: 0,
      prevAnswerText: "",
      prevIsCorrectAnswer: false,
      isSouruby: false,
    }
  );
  
  const emit = defineEmits<{
    (e: 'is-error', id: boolean): void,
    (e: 'press-enter'): void,
    (e: 'set-is-focus', id: any): void,
    (e: 'input-text', id: string): void,
  }>()

  const prefixText = computed(() => {
    return md.render(props.answer.body.prefix);
  })
  const suffixText = computed(() => {
    return md.render(props.answer.body.suffix);
  })

  function isError(value: boolean){
    error.value = value
    emit("is-error", value)
  }
</script>
